import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from '../../../models/utilities/filter-bar';
import { ListColumn, SelectedSort } from '../../../models/utilities/list-header';
import { PageData } from '../../../models/utilities/paged-request';
import { ApiEndpoints, GlobalConstants } from '../../../utils/app-constants';
import { AppUtils } from '../../../utils/app-utils';
import { RouteAreaMetadata } from '../enums/route-area';
import {DivisionMetadata} from "../../../models/ordering/enums/division";
import {forEach} from "lodash";

export class DeliveryPlanningFilters implements IFilterBar {

    public paginationInfo   : PageData = new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);
    public baseUrl          : string = ApiEndpoints.TRANSPORTATION_PLANNING_ROUTES;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[];
    public selectedSort     : SelectedSort;
    
    constructor() {
       
        // Set our table columns
        this.columns = [
            new ListColumn('Stop Name', 'stopName', true),
            new ListColumn('Job Site', 'isJobSite', true),
            new ListColumn('City', 'city', true),
            new ListColumn('State', 'state', true),
            new ListColumn('Units', ''),
            new ListColumn('Singles', ''),
            new ListColumn('Sections', ''),
            new ListColumn('Feet', ''),
            new ListColumn('Weight', ''),
            new ListColumn('Freight', '')
        ];

        // Create our Filter Groups
        const byMaxCutoff   = this.buildMaxCutoff();
        const byDealer      = this.buildDealer();
        const byOrderId     = this.buildOrderId();
        const byGeography   = this.buildGeography();
        const byDivision    = this.buildDivision();
        
        this.filters.push(
            byMaxCutoff, byDealer, byOrderId, byGeography, byDivision
        );

    }

    // #region Group Builders

    private buildGeography() {        
        const bySource = new FilterGroup('Route Area', 'checkboxes', 'areas');
        bySource.opts = AppUtils.enumMetadataToFilters(RouteAreaMetadata);

        bySource.opts.forEach((itm : FilterBarInputOpt) => {
            if (itm.qsValue === 0) {
                itm.data = true;
            }
            else {
                itm.data = false;
            }
        });

        return bySource;
    }

    private buildMaxCutoff() {
        const byDate = new FilterGroup('Max Cutoff', 'dateplus', 'maxCutoff');        
        const opt1 = new FilterBarInputOpt('Max Cutoff', {
            selectedDate: {
                qsValue: new Date(),
                qsName: 'maxCutoff'
            },
            checkboxValue: {
                qsValue: true,
                qsName: 'matchDayOfWeek'
            }
        });
        
        byDate.opts = [opt1];

        return byDate;
    }

    private buildDealer() {
        const byDealer = new FilterGroup('Dealer', 'dealer', 'dealerId');        
        const opt1 = new FilterBarInputOpt('Dealer', '');
        
        byDealer.opts = [opt1];

        return byDealer;
    }

    private buildOrderId() {
        const byOrderId = new FilterGroup('Order ID', 'text', 'orderId');        
        const opt1 = new FilterBarInputOpt('Order ID', '');
        
        byOrderId.opts = [opt1];

        return byOrderId;
    }
    
    private buildDivision() {
        const byDivision = new FilterGroup('Division', 'checkboxes', 'division');
        byDivision.opts = AppUtils.enumMetadataToFilters(DivisionMetadata);
        forEach(byDivision.opts, (itm : FilterBarInputOpt) => {
            if (itm.qsValue === 0) {
                itm.data = true;
            }
        });

        return byDivision;
    }

    // #endregion

}
